import { put, takeEvery } from "redux-saga/effects";
import { GET_FILTERED_PRODUCTS, GET_PRODUCTS, GET_PRODUCTS_DETAIL, SET_PRODUCTS, SET_PRODUCTS_DETAIL } from "../ConstAction";
import ProductsApiRequests from "../../Services/Products";

function* getProducts(data) {
    try {
        let response = yield ProductsApiRequests.requestproducts(data?.data);
        yield put({
            type: SET_PRODUCTS,
            response,
        })
        data.setLoading(false)

    } catch (err) {
        // data.setLoading(false)
    }
}
function* getProductdetails(data) {
    try {
        let response = yield ProductsApiRequests.requestProductdetails(data?.data);
        data.setLoading(false)
        yield put({
            type: SET_PRODUCTS_DETAIL,
            response,
        })
        // data.setLoading(false)

    } catch (err) {
        // data.setLoading(false)
    }
}

function* getfilteredProducts(data) {
    try {
        let response = yield ProductsApiRequests.requestfilteredProducts(data?.data);
        yield put({
            type: SET_PRODUCTS,
            response,
        })
        data.setLoading(false)

    } catch (err) {
        // data.setLoading(false)
    }
}
// Defination of all Saga
function* Productssaga() {
    yield takeEvery(GET_PRODUCTS, getProducts);
    yield takeEvery(GET_PRODUCTS_DETAIL, getProductdetails);
    yield takeEvery(GET_FILTERED_PRODUCTS, getfilteredProducts);
}
export default Productssaga;